<template>
  <div>
    <p class="cm-mg-p-wzd">
      {{ $t('common_words.sub_category_fill_fields') }}
    </p>
    <hr />
    <div class="row">
      <div
        class="col-12 col-sm-2 pr-0 mr-3"
        style="display: flex; align-items: center"
      >
        <label class="mb-3"
          >{{ $t('common_words.sub_categories_num') }} *</label
        >
      </div>
      <div class="col-6 col-sm-1">
        <fg-input
          type="number"
          v-model.number="sub_number"
          name="common_words.sub_category_number"
          v-validate="modelValidations.sub_number"
          :error="getError('common_words.sub_category_number', true)"
          placeholder="3"
          min="0"
          @change="updateNumSubCat()"
          @blur="updateSubCat"
        ></fg-input>
      </div>
    </div>
    <span v-for="index in sub_number" :key="index">
      <card class="custom-audit-card shadow-sm">
        <div class="row">
          <div class="col-1">
            <fg-input
              type="number"
              class="required-second-step"
              :label="$t('common_words.order_request')"
              :min="1"
              v-model.number="model.subcategoryOrder[index - 1]"
              placeholder="1"
            ></fg-input>
          </div>
          <div class="col-md-6">
            <fg-input
              type="text"
              class="required-second-step"
              :label="`${$t('common_words.sub_category_name')}: *`"
              v-model="model.sub_category_names[index - 1]"
              :placeholder="`${$t('common_words.sub_category_name')}...`"
              @blur="updateSubCat"
            ></fg-input>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-12 col-sm-2 pr-0" style="margin-right: -30px">
            <label class="mt-2">{{ $t('common_words.number_of_tasks') }}</label>
          </div>
          <div class="col-6 col-sm-1 pl-0">
            <fg-input
              type="number"
              v-model.number="model.tasks_number[index - 1]"
              class="required-second-step"
              placeholder="3"
              min="0"
              @change="updateNumTask(index - 1)"
              @blur="updateTasks(index - 1)"
            ></fg-input>
          </div>
          <div class="col-8" style="border-left: 1px solid #cecece">
            <span v-for="i in model.tasks_number[index - 1]" :key="i">
              <div class="row">
                <div class="col-2 col-sm-1 mr-3">
                  <fg-input
                    type="number"
                    style="width: 60px"
                    class="required-second-step"
                    :label="$t('common_words.order_request')"
                    placeholder="1"
                    :min="1"
                    v-model.number="model.task_order[index - 1 + '' + (i - 1)]"
                  ></fg-input>
                </div>
                <div class="col-12 col-sm-7">
                  <fg-input
                    class="required-second-step"
                    v-model="model.task_names[index - 1 + '' + (i - 1)]"
                    type="text"
                    :label="$t('common_words.name_of_the_task')"
                    :placeholder="`${$t(
                      'common_words.task_number_symbol'
                    )}${i}`"
                    @blur="updateTasks(index - 1)"
                  ></fg-input>
                </div>
                <div class="col-3">
                  <label>{{ $t('common_words.required_questionmark') }}</label>
                  <br />
                  <l-switch
                    class="mt-2"
                    style="display: block"
                    v-model="model.is_required[index - 1 + '' + (i - 1)]"
                    on-text="ON"
                    off-text="OFF"
                  >
                  </l-switch>
                </div>
              </div>
            </span>
          </div>
        </div>
      </card>
    </span>
  </div>
</template>
<script>
import { getRepeatsFromArray } from 'src/util/Util.js';
import { Switch as LSwitch } from 'src/components';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinForm from 'src/mixins/forms/mixin-form';
import store from '@/store';
import SweetAlert from 'src/class/Alerts';
import i18n from 'src/i18n';

export default {
  components: {
    LSwitch,
  },

  data() {
    return {
      model: {
        subcategoryOrder: [1],
        sub_category_names: [],
        sub_category_ids: [],
        tasks_number: [],
        task_ids: {},
        task_order: {},
        task_names: {},
        is_required: {},
      },
      modelValidations: {
        sub_number: {
          required: true,
          min: 0,
        },
      },
      sub_number: 1,
      tasks_number_initial: [],
      initialLength: 1,
    };
  },
  mixins: [MixinForm, MixinPermissions],
  methods: {
    nextNumberInOrder(modelData, index) {
      const maxOrder = Math.max(...modelData);
      let result = Array.from(
        { length: isFinite(maxOrder) ? maxOrder : 1 },
        (v, i) => i + 1
      ).filter((element) => !modelData.includes(element));
      result = result.sort();

      if (result.length > 0) this.$set(modelData, index, result[0]);
      else this.$set(modelData, index, isFinite(maxOrder) ? maxOrder + 1 : 1);

      return modelData;
    },

    nextNumberInOrderTask(index, val) {
      const values = [];
      let actuallyValues = [];
      let a = 0;
      while (a < val) {
        const b = this.model.task_order[`${index}${a}`];
        values.push(b ? b : val);
        if (b) actuallyValues[`${index}${a}`] = b;
        a++;
      }

      const maxOrder = Math.max(...values);
      let result = Array.from(
        { length: isFinite(maxOrder) ? maxOrder : 1 },
        (v, i) => i + 1
      ).filter((element) => !Object.values(actuallyValues).includes(element));
      result = result.sort();

      if (result.length > 0)
        this.$set(this.model.task_order, `${index}${val - 1}`, result[0]);
      else
        this.$set(
          this.model.task_order,
          `${index}${val - 1}`,
          isFinite(maxOrder) ? maxOrder + 1 : val
        );
    },

    updateNumTask(index) {
      const val = this.model.tasks_number[index];
      const taskOrder = this.model.task_order;
      const actuallyValues = [];
      let a = 0;

      while (a < val + 1) {
        const b = taskOrder[`${index}${a}`];
        if (b) actuallyValues.push(b);
        a++;
      }

      if (val < actuallyValues.length) {
        a = 0;
        while (a < actuallyValues.length) {
          delete taskOrder[`${index}${a}`];
          a++;
        }
      } else
        Array.from({ length: val }, (v, i) => i + 1).forEach((element) => {
          const exist = taskOrder[`${index}${element - 1}`];
          if (!exist || exist == '' || Number(exist) === 0) {
            this.nextNumberInOrderTask(index, element);
          }
        });

      this.updateArrays(index, true);
    },

    updateNumSubCat() {
      if (this.sub_number === 0) this.$set(this.model, 'subcategoryOrder', []);
      else if (this.sub_number < this.model.subcategoryOrder.length) {
        const orderTmp = [...this.model.subcategoryOrder];
        orderTmp.splice(this.sub_number);
        this.$set(this.model, 'subcategoryOrder', orderTmp);
      } else
        Array.from({ length: this.sub_number }, (v, i) => i + 1).forEach(
          (element) => {
            const exist = this.model.subcategoryOrder[element - 1];
            if (!exist || exist == '' || Number(exist) === 0) {
              this.nextNumberInOrder(this.model.subcategoryOrder, element - 1);
            }
          }
        );

      this.updateArrays(0);
    },

    updateOrderSubCat() {
      const result = getRepeatsFromArray(this.model.subcategoryOrder);
      if (result.length > 0) {
        SweetAlert.warning(
          `${i18n.t('sweet_alert.audit.value')} ${result[0]} ${i18n.t(
            'sweet_alert.audit.field'
          )}, ${i18n.t('sweet_alert.audit.subcategory_order')}, ${i18n.t(
            'sweet_alert.audit.duplicated'
          )}.`
        );
        return false;
      }
      return true;
    },

    validateRepeated(
      lista,
      length,
      isObject = false,
      indexConcat = 0,
      fieldMessage = i18n.t('message.audit_fieldmessage.task_name')
    ) {
      let index = isObject ? Object.keys(this.model.task_names) : isObject;
      let a = 0;
      let b = 0;
      let c = 0;
      let d = 0;
      let num = 0;

      while (a < length) {
        b = lista[isObject ? indexConcat + '' + a : a];
        if (typeof b === 'string') b = b.trim();
        c = 0;
        while (c < length) {
          d = lista[isObject ? indexConcat + '' + c : c];
          if (typeof d === 'string') d = d.trim();
          if (d && b === d) {
            num++;
          }

          if (num > 1) {
            SweetAlert.warning(
              `${i18n.t(
                'message.audit_fieldmessage.value_exists'
              )} '${d}' ${i18n.t(
                'message.audit_fieldmessage.field'
              )}, ${fieldMessage}`
            );
            return true;
          }
          c++;
        }
        a++;
        num = 0;
      }

      return false;
    },

    validate() {
      let elThis = this;
      if (!elThis.updateOrderSubCat()) return false;
      if (
        elThis.validateRepeated(
          this.model.sub_category_names,
          this.model.sub_category_names.length,
          false
        )
      ) {
        return false;
      }

      for (
        let index = 0;
        index < this.model.sub_category_names.length;
        index++
      ) {
        if (
          elThis.validateRepeated(
            this.model.task_order,
            Object.keys(this.model.task_order).length,
            true,
            index,
            i18n.t('message.audit_fieldmessage.order_task')
          )
        ) {
          return false;
        }

        if (
          elThis.validateRepeated(
            this.model.task_names,
            Object.keys(this.model.task_names).length,
            true,
            index
          )
        ) {
          return false;
        }
      }

      return this.$validator
        .validateAll()
        .then((res) => {
          this.model.task_order = Object.assign({}, this.model.task_order);

          Object.keys(this.model.task_names).forEach((key) => {
            if (this.model.is_required[key] === undefined)
              this.model.is_required[key] = false;
          });

          this.$emit('on-validated', res, this.model);
          this.$emit('fillAuditForm', 'secondStep', {
            user_id: this.$store.state.auth.user.id,
          });
          return res;
        })
        .then((resp) => {
          if (!resp) return resp;

          return store.dispatch(
            'utils/validationInputsRequired',
            '-second-step'
          );
        });
    },

    updateTasks(indexConcat) {
      this.validateRepeated(
        this.model.task_names,
        Object.keys(this.model.task_names).length,
        true,
        indexConcat
      );
    },

    updateSubCat() {
      this.validateRepeated(
        this.model.sub_category_names,
        this.model.sub_category_names.length,
        false,
        0,
        i18n.t('common_words.sub_category_name')
      );
    },

    deleteNotCoincidence(data, index) {
      let toDelete = [];
      data.forEach((element) => {
        if (!(element + '').startsWith(index + '')) {
          toDelete.push(data.indexOf(element + ''));
        }
      });

      toDelete.sort(function (x, y) {
        return y - x;
      });

      toDelete.forEach((i) => {
        data.splice(i, 1);
      });

      return data;
    },

    updateArrays(index, isObject = false) {
      let tmp = isObject
        ? this.deleteNotCoincidence(Object.keys(this.model.task_names), index)
        : null;

      if (isObject) {
        this.deleteNotCoincidence(Object.keys(this.model.task_ids), index);
      }

      let ln =
        (isObject ? tmp.length : this.model.sub_category_names.length) -
        (isObject ? this.model.tasks_number[index] : this.sub_number);

      if (ln > 0) {
        if (isObject) {
          if (
            ln == 1 &&
            (this.model.tasks_number[index] >
              this.tasks_number_initial[index] ||
              (this.model.tasks_number[index] ==
                this.tasks_number_initial[index] &&
                tmp.length > this.tasks_number_initial[index]) ||
              this.model.tasks_number[index] < this.tasks_number_initial[index])
          ) {
            delete this.model.task_ids[
              index + '' + this.model.tasks_number[index]
            ];
            delete this.model.task_names[
              index + '' + this.model.tasks_number[index]
            ];
            delete this.model.is_required[
              index + '' + this.model.tasks_number[index]
            ];
          } else if (ln > 1) {
            for (let i = this.tasks_number_initial[index]; i < ln; i++) {
              delete this.model.task_ids[index + '' + (i - 1)];
              delete this.model.task_names[index + '' + (i - 1)];
              delete this.model.is_required[index + '' + (i - 1)];
            }
          }
        } else {
          if (
            ln == 1 &&
            (this.sub_number > this.initialLength ||
              (this.sub_number == this.initialLength &&
                this.model.sub_category_names.length > this.initialLength) ||
              this.sub_number < this.initialLength)
          ) {
            let k = this.model.sub_category_names.length - 1;

            for (let i = 0; i < this.model.tasks_number[k]; i++) {
              delete this.model.task_ids[k + '' + i];
              delete this.model.task_names[k + '' + i];
              delete this.model.is_required[k + '' + i];
            }

            this.model.sub_category_ids.pop();
            this.model.sub_category_names.pop();
            this.model.tasks_number.pop();
          } else if (ln > 1) {
            for (let j = ln; j > 0; j--) {
              for (let i = 0; i < this.model.tasks_number[j]; i++) {
                delete this.model.task_ids[k + '' + i];
                delete this.model.task_names[k + '' + i];
                delete this.model.is_required[k + '' + i];
              }
            }

            this.model.sub_category_ids.splice(this.initialLength, ln);
            this.model.sub_category_names.splice(this.initialLength, ln);
            this.model.tasks_number.splice(this.initialLength, ln);
          }
        }
      }
    },
  },

  created() {
    let editForm = {};
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.sub_number = editForm.sub_category_ids.length;
      this.model.subcategoryOrder = editForm.sub_category_order;

      editForm.sub_category_names.forEach((element, index) => {
        this.model.sub_category_names.push(element);
        this.initialLength = this.model.sub_category_names.length;
        this.model.sub_category_ids.push(editForm.sub_category_ids[index]);
        this.model.tasks_number.push(
          editForm.sub_categories[index].task.length
        );
        this.tasks_number_initial.push(
          editForm.sub_categories[index].task.length
        );

        let tmp = editForm.task_names;
        let tmpIds = editForm.task_ids;
        let tmpOrder = editForm.task_order;
        let tmpIsRequired = editForm.task_requireds;
        let len = this.model.tasks_number[index];

        for (let i = 0; i < tmp.length; i++) {
          const items = tmp[i];
          const itemsIds = tmpIds[i];
          const itemsOrder = tmpOrder[i];
          const itemsIsRequired = tmpIsRequired[i];

          if (i >= len) {
            if (len - 1 == 0) {
              tmp.shift();
              tmpIds.shift();
              tmpOrder.shift();
              tmpIsRequired.shift();
            } else {
              tmp.splice(0, len);
              tmpIds.splice(0, len);
              tmpOrder.splice(0, len);
              tmpIsRequired.splice(0, len);
            }
            break;
          }

          if (items[editForm.sub_categories[index].id]) {
            this.$set(
              this.model.task_names,
              index + '' + i,
              items[editForm.sub_categories[index].id]
            );
            this.$set(
              this.model.task_ids,
              index + '' + i,
              itemsIds[editForm.sub_categories[index].id]
            );
            this.$set(
              this.model.task_order,
              index + '' + i,
              itemsOrder[editForm.sub_categories[index].id]
            );
            this.$set(
              this.model.is_required,
              index + '' + i,
              itemsIsRequired[editForm.sub_categories[index].id] === 1
                ? true
                : false
            );
          }
        }
      });
    }
  },
};
</script>
<style>
.custom-audit-card .card-body {
  padding: 20px !important;
}
</style>
